import { PrivacyStatus, apiClient } from '@/api';
import { useEffect, useState } from 'react';

import PrivacyPolicyModal from './PrivacyPolicyModal';

type Props = {
  onResolved: (satisfied: boolean) => void;
};

export default function PrivacyProvider({ onResolved }: Props) {
  const [status, setStatus] = useState<PrivacyStatus | null>(null);
  const [unreachable, setUnreachable] = useState(false);

  const refresh = () => {
    apiClient
      .getPrivacyStatus()
      .then((s) => {
        setStatus(s);
        setUnreachable(false);
      })
      .catch(() => setUnreachable(true));
  };

  useEffect(refresh, []);

  useEffect(() => {
    if (unreachable) {
      onResolved(true);
      return;
    }
    if (status === null) {
      onResolved(false);
      return;
    }
    onResolved(!status.needs_reprompt);
  }, [unreachable, status, onResolved]);

  if (unreachable || status === null) {
    return null;
  }
  return status.needs_reprompt ? (
    <PrivacyPolicyModal mode="accept" onAccepted={refresh} />
  ) : null;
}
